import { ButtonType, ButtonWidget } from '@tableau/widgets';
import React from 'react';
import _ from 'underscore';

import { ConnectedExplorer } from '~src/spacesPlatform/components/Explorer/ConnectedExplorer';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { BrowserTitleService } from '../../commonInfra/services/BrowserTitleService';
import { CreateScheduleAction } from '../../spacesPlatform/components/Explorer/CreateContent/CreateContentActionsList';
import { SpaceHeaderWithTotalItemsCount } from '../../spacesPlatform/components/header/SpaceHeaderWithTotalItemsCount';
import { SpaceContainerStyles } from '../../spacesPlatform/style/SpaceContainerStyles';

export interface AllSchedulesSpaceOwnProps {
  readonly siteName: string;
}

export interface AllSchedulesSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedSchedules: number;
}

export interface AllSchedulesSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
}

export type AllSchedulesSpaceProps = AllSchedulesSpaceOwnProps & AllSchedulesSpaceStateProps & AllSchedulesSpaceDispatchProps;

export class AllSchedulesSpace extends React.PureComponent<AllSchedulesSpaceProps> {
  public componentDidMount() {
    BrowserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.schedules() });
    this.props.requestSpaceContents();
  }

  public componentDidUpdate(prevProps: AllSchedulesSpaceProps) {
    if(!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.schedules()}
          testId={'schedules'}
          count={this.props.numberOfFetchedSchedules}
          countUpToDate={!this.props.isBusyFetchingItems}
        />
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            supportedDisplayModes={['list']}
            toolbarProps={{
              supportFilterPanel: false,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: newScheduleButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.schedulesEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  };
}

export function newScheduleButton(): JSX.Element {
  const appState = getAppStore().getState();
  const createScheduleAction = CreateScheduleAction;
  if (createScheduleAction.isVisible(appState, 'schedules') && createScheduleAction.isClickable()) {
    const reduxAction = createScheduleAction.createReduxAction();
    const handleClick = () => getAppStore().dispatch(reduxAction);
    return (
      <ButtonWidget
        children={createScheduleAction.title()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        tb-test-id={'action-create-new-schedule'}
        testId={'action-create-new-schedule'}/>
    );
  }
  return null;
}
